/**
 * Availability / lead-time messaging.
 *
 * Ported from the source store's core 4-metafield status logic
 * (product/variant tag-based overrides intentionally NOT included per scope).
 *
 * Listens for this theme's native `variant:change` document event
 * (dispatched by the VariantSelects custom element in global.js) and
 * re-renders the message for whichever variant is now selected.
 */
(function () {
  'use strict';

  var InventoryStatus = {
    AVAILABLE: 'available',
    OUT_OF_STOCK: 'out_of_stock',
    OUT_OF_STOCK_PURCHASABLE: 'out_of_stock_purchasable',
    DISCONTINUED: 'discontinued',
    ETA: 'eta'
  };

  function isSet(value) {
    return value !== null && value !== undefined && value !== '' && value !== '---';
  }

  // Ported verbatim from the source store's filterShippingTag()
  function filterShippingTag(shippingTag) {
    if (!isSet(shippingTag)) return '';

    var biggerDate = shippingTag.replace(/(SHIPPING|WK|VARIABLE|WH)/g, '');

    if (shippingTag.endsWith('WH')) {
      return '<span>' + biggerDate.replace('-', ' to ') +
        ' business days to leave the warehouse</span> Lead times may be extended based on availability, customer service will contact you with any updates.';
    }

    if (['SHIPPING2-3VARIABLE', 'SHIPPING3-4VARIABLE', 'SHIPPING3-5VARIABLE'].indexOf(shippingTag) !== -1) {
      return '<span>' + biggerDate.replace('-', ' to ') + ' weeks to ship.</span>';
    }

    var txt = '';
    if (/\dWK$/.test(shippingTag) || /\dWKVARIABLE$/.test(shippingTag) || /\dWKSVARIABLE$/.test(shippingTag)) {
      txt = biggerDate.replace('-', ' to ') + ' weeks to ship';
    } else if (/\d$/.test(shippingTag) || /\dVARIABLE$/.test(shippingTag)) {
      txt = '<span>' + biggerDate.replace('-', ' to ') +
        ' business days to ship.</span> Lead times may be extended based on availability, customer service will contact you with any updates.';
    }
    return txt;
  }

  // Ported verbatim from the source store's getETAShippingMessage()
  function getETAShippingMessage(etaDateStr) {
    var etaDate = new Date(etaDateStr);
    var today = new Date();
    var diffSeconds = (etaDate - today) / 1000;
    var week = 60 * 60 * 24 * 7;
    var minWeek = Math.max(1, Math.floor(diffSeconds / week));
    var maxWeek = minWeek + 2;

    if (etaDate < today) {
      return 'Please contact support for shipping information.';
    }
    return minWeek + ' to ' + maxWeek + ' weeks to ship';
  }

  function AvailabilityController(sectionId) {
    this.sectionId = sectionId;
    this.container = document.getElementById('availability-' + sectionId);
    if (!this.container) return;

    var dataEl = document.getElementById('AvailabilityData-' + sectionId);
    this.data = dataEl ? JSON.parse(dataEl.textContent) : { shipping_tag: null, variants: {} };
    this.quantityInputId = this.container.dataset.quantityInputId;

    document.addEventListener('variant:change', this.handleVariantChange.bind(this));

    var initialId = this.container.dataset.initialVariantId;
    if (initialId) this.render(initialId);
  }

  AvailabilityController.prototype.handleVariantChange = function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !this.data.variants.hasOwnProperty(variant.id)) return;
    this.render(variant.id);
  };

  AvailabilityController.prototype.render = function (variantId) {
    var info = this.data.variants[variantId];
    if (!info) {
      this.applyState('', false, null);
      return;
    }

    var status = info.status;

    if (!isSet(status)) {
      this.applyState('', false, null);
      return;
    }

    var message = '';
    var hideBuyButtons = false;
    var maxQty = null;

    switch (status) {
      case InventoryStatus.AVAILABLE:
        message = filterShippingTag(this.data.shipping_tag);
        break;

      case InventoryStatus.ETA:
        message = isSet(info.eta_date) ? getETAShippingMessage(info.eta_date) : '';
        break;

      case InventoryStatus.OUT_OF_STOCK_PURCHASABLE:
        message = 'For Shipping Information Please Contact Support.';
        break;

      case InventoryStatus.OUT_OF_STOCK:
        message = 'For Shipping Information Please Contact Support.';
        hideBuyButtons = true;
        break;

      case InventoryStatus.DISCONTINUED:
        var availableQty = parseInt(info.available_quantity, 10) || 0;
        if (availableQty > 0) {
          message = filterShippingTag(this.data.shipping_tag);
          maxQty = availableQty;
        } else {
          message = '';
          hideBuyButtons = true;
        }
        break;

      default:
        message = '';
    }

    this.applyState(message, hideBuyButtons, maxQty);
  };

  AvailabilityController.prototype.applyState = function (message, hideBuyButtons, maxQty) {
    this.container.innerHTML = message;
    this.container.toggleAttribute('hidden', message === '');

    var scope = this.container.closest('[data-section]') || document;
    scope.querySelectorAll('.buy-buttons').forEach(function (el) {
      el.toggleAttribute('hidden', hideBuyButtons);
    });

    if (this.quantityInputId) {
      var qtyInput = document.getElementById(this.quantityInputId);
      if (qtyInput) {
        if (maxQty) {
          qtyInput.setAttribute('max', maxQty);
          if (parseInt(qtyInput.value, 10) > maxQty) qtyInput.value = maxQty;
        } else {
          qtyInput.removeAttribute('max');
        }
      }
    }

    // NOTE: the source store's "show back-in-stock button" branch was also a
    // stub there (no real UI wired up). If you have a back-in-stock app/flow
    // on this store, hook it in here for the OUT_OF_STOCK and
    // DISCONTINUED-with-zero-qty cases.
  };

  document.querySelectorAll('[id^="availability-"]').forEach(function (el) {
    var sectionId = el.id.replace('availability-', '');
    new AvailabilityController(sectionId);
  });
})();
